import React, { useState } from "react";
import "./SecaoDiagnosticoESG.css";

const estados = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

const nomesEstados = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

function mascaraTelefone(valor) {
  const numeros = valor.replace(/\D/g, "").slice(0, 11);

  if (!numeros) return "";

  if (numeros.length <= 2) {
    return `(${numeros}`;
  }

  if (numeros.length <= 6) {
    return numeros.replace(/^(\d{2})(\d+)/, "($1) $2");
  }

  if (numeros.length <= 10) {
    return numeros.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  }

  return numeros.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
}

export default function SecaoDiagnosticoESG() {
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const dadosFormulario = Object.fromEntries(new FormData(form).entries());

    setLoading(true);
    setFeedback("");

    try {
      const response = await fetch("/api/salvar-diagnostico.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dadosFormulario),
      });

      const resultado = await response.json();

      if (!response.ok || !resultado.success) {
        throw new Error(resultado.message || "Erro ao enviar formulário.");
      }

      setFeedback(
        "Dados enviados com sucesso. O download começará em instantes.",
      );

      form.reset();

      if (resultado.downloadUrl) {
        window.location.href = resultado.downloadUrl;
      }
    } catch (error) {
      setFeedback(
        error.message || "Não foi possível enviar os dados. Tente novamente.",
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="diagnostico-esg-wrapper" id="diagnostico-esg">
      <div className="container diagnostico-esg-container">
        <h2 className="titulo-secao scroll-reveal-zoom text-center">
          Diagnóstico ESG Gratuito
          <span className="barra"></span>
        </h2>

        <p className="mb-5 scroll-reveal-zoom subtitulo-clean text-center">
          Avalie o impacto ambiental e a maturidade governamental da sua empresa
          com nossa ferramenta técnica especializada.
        </p>

        <div className="row gy-5 gx-lg-5 align-items-start">
          <div className="col-12 col-lg-5 scroll-reveal-zoom">
            <div className="diagnostico-info">
              <h3 className="diagnostico-info-titulo">
                Por que realizar o <br />
                <span>Diagnóstico ESG?</span>
              </h3>

              <p className="diagnostico-info-texto">
                Nossa ferramenta técnica especializada ajuda sua empresa a
                identificar impactos ambientais críticos e medir a maturidade da
                sua governança corporativa, transformando sustentabilidade em
                valor estratégico.
              </p>

              <ul className="diagnostico-lista">
                <li>
                  <span>✓</span>
                  Identificação de riscos operacionais
                </li>

                <li>
                  <span>✓</span>
                  Melhoria na reputação da marca
                </li>

                <li>
                  <span>✓</span>
                  Atratividade para investidores
                </li>

                <li>
                  <span>✓</span>
                  Conformidade com legislações
                </li>
              </ul>
            </div>
          </div>

          <div className="col-12 col-lg-7 scroll-reveal-glass">
            <div className="diagnostico-card">
              <form
                className="diagnostico-form"
                id="esg-form"
                onSubmit={handleSubmit}
              >
                <div className="row g-3 g-md-4">
                  <div className="col-12 col-md-6">
                    <label htmlFor="nome">Nome Completo*</label>
                    <input
                      id="nome"
                      name="nome"
                      type="text"
                      placeholder="Digite seu nome"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="email">E-mail*</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="seu@empresa.com.br"
                      required
                      pattern="^[^\s@]+@[^\s@]+\.[^\s@]{2,}$"
                      title="Digite um e-mail válido. Exemplo: seu@empresa.com.br"
                      onInvalid={(event) => {
                        event.target.setCustomValidity(
                          "Digite um e-mail válido. Exemplo: seu@empresa.com.br",
                        );
                      }}
                      onInput={(event) => {
                        event.target.setCustomValidity("");
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="telefone">Telefone*</label>
                    <input
                      id="telefone"
                      name="telefone"
                      type="tel"
                      inputMode="numeric"
                      maxLength={15}
                      placeholder="(00) 00000-0000"
                      required
                      onChange={(event) => {
                        event.target.value = mascaraTelefone(
                          event.target.value,
                        );
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="estado">Estado*</label>
                    <select id="estado" name="estado" required defaultValue="">
                      <option value="" disabled>
                        Selecione seu estado
                      </option>

                      {estados.map((uf) => (
                        <option key={uf} value={uf}>
                          {nomesEstados[uf]}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="empresa">Nome da Empresa*</label>
                    <input
                      id="empresa"
                      name="empresa"
                      type="text"
                      placeholder="Nome jurídico ou fantasia"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="porte">Porte da Empresa*</label>
                    <select id="porte" name="porte" required defaultValue="">
                      <option value="" disabled>
                        Selecione o porte
                      </option>
                      <option value="MEI">MEI</option>
                      <option value="Microempresa">Microempresa</option>
                      <option value="Pequena Empresa">Pequena Empresa</option>
                      <option value="Média Empresa">Média Empresa</option>
                      <option value="Grande Empresa">Grande Empresa</option>
                    </select>
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="segmento">Segmento*</label>
                    <select
                      id="segmento"
                      name="segmento"
                      required
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Selecione o segmento
                      </option>
                      <option value="Industria">Indústria</option>
                      <option value="Servicos">Serviços</option>
                      <option value="Agronegocio">Agronegócio</option>
                      <option value="Construcao">Construção Civil</option>
                      <option value="Tecnologia">Tecnologia</option>
                    </select>
                  </div>

                  <div className="col-12 col-md-6">
                    <label htmlFor="cargo">Cargo*</label>
                    <input
                      id="cargo"
                      name="cargo"
                      type="text"
                      placeholder="Ex: Gerente de Sustentabilidade"
                      required
                    />
                  </div>

                  <div className="col-12">
                    <label htmlFor="profissao">Profissão*</label>
                    <input
                      id="profissao"
                      name="profissao"
                      type="text"
                      placeholder="Ex: Engenheiro Ambiental"
                      required
                    />
                  </div>
                </div>

                {/* <div className="diagnostico-lgpd">
                  <input id="lgpd" name="lgpd" type="checkbox" required />

                  <label htmlFor="lgpd">
                    Autorizo o tratamento dos meus dados para contato comercial.
                  </label>
                </div> */}

                <button
                  className="diagnostico-btn"
                  id="submit-btn"
                  type="submit"
                  disabled={loading}
                >
                  <span>⬇</span>
                  {loading ? "Enviando..." : "Baixar Diagnóstico ESG"}
                </button>

                {feedback && (
                  <div className="diagnostico-feedback">{feedback}</div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}